const dashboard = {
  dashboard: {
    description: 'Hi {{userName}}!',
    noUpcoming: 'Please schedule a connection.',
    daysLeft: 'Only {{days}} days left until your scheduled satellite connection.',
    tabs: {
      monitoring: 'Monitoring',
      paymentAnalytics: 'Payment Analytics'
    },
    paymentAnalytics: {
      periodOptions: {
        sixMonths: '6 Months',
        oneMonth: '1 Month',
        oneWeek: '1 Week'
      },
      overview: {
        title: 'Overview',
        totalPayments: 'Total Payments',
        totalAmount: 'Total Amount',
        pending: 'Pending',
        completed: 'Completed',
        cancellationReq: 'Cancellation Request',
        refunded: 'Refunded',
        countUnit: ' cases'
      },
      priceMonitor: {
        title: 'Price Monitor',
        costBySatellite: 'Cost by Satellite',
        usageByAntenna: 'Usage Ratio by Antenna',
        usageByPayment: 'Usage Ratio by Payment Method',
        costTooltipLabel: 'Cost'
      },
      paymentMethods: {
        bank_transfer: 'Bank Transfer',
        card_payment: 'Card Payment',
        free_usage: 'Free Usage' 
      }
    }
  }
};

export default dashboard;